import { Observable, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataService } from "src/app/shared/services/data.service";
import { Result } from "src/app/shared/model/response.model";

@Injectable({
  providedIn: "root",
})
export class TemplateService {
  constructor(private http: HttpClient, private service: DataService) {}
  createTemplate(data: any): Observable<Result> {
    let url = "smxEmailPlatform/EmailTemplate/saveTemplate";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getAllList(data: any): Observable<Result> {
    let url = "smxEmailPlatform/EmailTemplate/getalltemplatelist";
    return this.service.post(url, data).pipe(
      tap((response: any) => {
        return response;
      })
    );
  }
  getByTemplateId(templateId: string): Observable<Result> {
    let url =
      "smxEmailPlatform/EmailTemplate/gettemplatebyid?templateId=" + templateId;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  // getAllSnippetlist(): Observable<Result> {
  //   let url = "smxEmailPlatform/EmailTemplate/getSnippetsList";
  //   return this.service.get(url, true).pipe<Result>(
  //     tap((response: any) => {
  //       return response;
  //     })
  //   );
  // }
  getAllSnippetList(data: any) {
    let url = "smxEmailPlatform/EmailTemplate/getallSnippetlist";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  deleteTemplate(id: any): Observable<Result> {
    let url = `smxEmailPlatform/EmailTemplate/deleteTemplate?templateId=${id}`;
    return this.service.delete(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
